import { useEffect, useState } from 'react';
import { getPendingCount, subscribeToLoading } from '../../services/loadingStore';
import './LoadingOverlay.css';

const LOADER_DELAY_MS = 250;

const LoadingOverlay = () => {
  const [pendingCount, setPendingCount] = useState(getPendingCount());
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => subscribeToLoading(setPendingCount), []);

  useEffect(() => {
    if (pendingCount > 0) {
      const timer = window.setTimeout(() => setIsVisible(true), LOADER_DELAY_MS);
      return () => window.clearTimeout(timer);
    }

    setIsVisible(false);
  }, [pendingCount]);

  if (!isVisible) return null;

  return (
    <div className="global-loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="global-loading-card">
        <div className="global-loading-spinner" aria-hidden="true" />
        <p>Traitement en cours...</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
